var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useEffect } from 'react';
import { Box, Button, LayoutControls } from '@pinwheel/origami';
import { useOpts } from '../../context';
import TitleFrame from '../../LinkApiRouter/components/TitleFrame';
import useFullSwitchAndMoreContext from './FullSwitchAndMore/hooks/useFullSwitchAndMoreContext';
import FullSwitchAndMoreProvider from './FullSwitchAndMore/context';
import useOnEnterHandler from '../../LinkApiRouter/hooks/useOnEnterHandler';
import useOrgName from '../../hooks/useOrgName';
import useSkipDepositConfirmation from '../../LinkApiRouter/hooks/useSkipDepositConfirmation';
import useAmountSelectionButtonText from '../../LinkApiRouter/hooks/useAmountSelectionButtonText';
import { useGetLocalizedString } from '../../hooks/useGetLocalizedString';
import AmountRadioButton from './FullSwitchAndMore/AmountRadioButton';
import PercentageRadioButton from './FullSwitchAndMore/PercentageRadioButton';
import RemainderRadioButton from './FullSwitchAndMore/RemainderRadioButton';
import useAmountSupported from './FullSwitchAndMore/hooks/useAmountSupported';
function LegacyInner(props) {
    var getLocalizedString = useGetLocalizedString();
    var _a = useOpts(), amountSelection = _a.amountSelection, setAmountSelection = _a.setAmountSelection, featureFlags = _a.featureFlags;
    var amountSupported = useAmountSupported();
    var orgName = useOrgName();
    var _b = useFullSwitchAndMoreContext(), isValid = _b.isValid, percentageSupported = _b.percentageSupported;
    useOnEnterHandler(isValid, props.onContinue);
    useSkipDepositConfirmation(props.onContinue);
    /*
     * We are eventually going to remove this component once full_switch
     * is supported on the long tail of platforms
     *
     * We are doing this hacky shit until then.
     */
    useEffect(function () {
        if ((amountSelection === null || amountSelection === void 0 ? void 0 : amountSelection.action) === 'full_switch')
            setAmountSelection({
                action: 'partial_switch',
                allocation: {
                    type: 'remainder',
                },
            });
    }, [amountSelection === null || amountSelection === void 0 ? void 0 : amountSelection.action, setAmountSelection]);
    var buttonText = useAmountSelectionButtonText();
    return (React.createElement(React.Fragment, null,
        React.createElement(TitleFrame, { title: getLocalizedString('DIRECT_DEPOSIT_SETTINGS'), subtitle: getLocalizedString('HOW_MUCH_TO_ORG', [orgName]) },
            React.createElement(Box, null,
                !(featureFlags === null || featureFlags === void 0 ? void 0 : featureFlags.disableRemainderSwitch) ? (React.createElement(RemainderRadioButton, null)) : null,
                amountSupported ? React.createElement(AmountRadioButton, null) : null,
                percentageSupported ? React.createElement(PercentageRadioButton, null) : null)),
        React.createElement(LayoutControls, null,
            React.createElement(Button, { "data-testid": "button", disabled: !isValid, onClick: props.onContinue, eventId: "AmountSelection-continue" }, buttonText))));
}
function Legacy(props) {
    return (React.createElement(FullSwitchAndMoreProvider, null,
        React.createElement(LegacyInner, __assign({}, props))));
}
export default Legacy;
